// @flow
import createStorage from "./EncryptedStorage";
import { decode, encode } from "../encryption/Encryption";

import type { KeyT } from "./EncryptedStorage";

const excludedKeys = [
  "access_token",
  "token_type",
  "refresh_token",
  "expires_in",
  "created",
  "jti",
  "cookieConsentBanner",
  "userCookieConsents",
  "utmExpid",
];

export const exclude = (key: KeyT) => excludedKeys.indexOf(key) > -1;

export const encryption = {
  decode,
  encode,
  exclude,
};

export const LocalStorage = window.localStorage && createStorage(window.localStorage, { encryption });

export default LocalStorage;
